export default __webpack_public_path__ + "static/media/uniswap.58916e3e.svg";